import React from 'react';
import { Component, createRef } from 'react';
import {Link,hashHistory} from 'react-router-dom';
import './styles.css'

class ArticleItem extends React.Component {

  
  constructor(props) {
    super(props);
    this.state={
      visible: false,
    }
    
  }
  //Se invoca inmediatamente después de que un componente se monte (se inserte en el árbol)
  componentDidMount() {
    //this.setState({show: aux});
    console.log("did mount");
    
  }
  handleClick=(e)=>{
    // 👇️ Use event.preventDefault() if you want to
    // prevent navigation
    e.preventDefault();
    /*let obj = {id_mate: this.props.id_mate,
      nombre: this.props.nombre,
      sigla: this.props.sigla,
    }*/
    //----pasa el item, compeltito totalmente
    this.props.onClick();
  }
  
  //---------------------------------------------------------------------
  render() {
    
    console.log(this.props.message);
    
    //let display = this.props.show ==true? 'block':'none';

    const message = this.props.message;
    //const alertClassName = `alert ${ this.alertClass(message.type) } alert-dismissible fade show`;
 
    return(
     
      <article style={{borderBottomColor: this.props.foreColor }}>   
        <header>
          {/*<h5 className="badge_abs"> 
              <span id="group"> 
                <button type="button" className="btn btn-info button_esp">  
                 <i className="fa fa-lg fa-bell"></i> 
                </button> 
                <span className="badge badge_esp badge-light">5</span> 
              </span> 
          </h5>*/}
          {/*<!-- -->*/}
         
          <Link to="/" onClick={(e)=> this.handleClick(e) } > 
            <div style={{ position:'relative' }}>
              <img  className="imagen" 
                    src={this.props.imgSrc}
                    style={{ maxHeight: '180px'}} alt=""/>
                <span className="fecha_fin" style={{ backgroundColor: this.props.foreColor, display: 'block' }}>
                <span className="bold">Materia</span>
              </span>
            </div>
            
            <h4 className="nombre">{ this.props.nombre }</h4>
            <div className="acceso">{ this.props.detalle }</div>  
          </Link>
        </header>

        <footer style={{ backgroundColor: this.props.foreColor}}>
          <div className="footback">
              <button className="favorito active" title="Desmarcar aula como favorita">
                  <i className="icono on fa fa-star"></i>
                  <i className="icono off far fa-star"></i> 
              </button>

              <Link to="/" className="retomar" onClick={(e)=>  this.handleClick(e) }>
                  <i className="icono fa fa-play-circle"></i> Ingresar</Link>
          </div>
        </footer>
      </article>
    );
  }
}

/*NuAlert.propTypes = {
  onClose: React.PropTypes.func,
  timeout: React.PropTypes.number,
  message: React.PropTypes.object.isRequired
};*/

ArticleItem.defaultProps = {
  timeout: 3000
};

export default ArticleItem;